var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"block w-full",on:{"click":function($event){return _vm.toggleAccordionItem()}}},[_vm._t("button",function(){return [_vm._v(" Insert default ")]},{"open":_vm.isOpen})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }